module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Size ของ Box Model ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBoxPosition'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Box Position\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicColor'
      }
    }
  }, [_vm._v("\n            Color   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-box-size"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Box Size\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-width"
    }
  }, [_vm._v("Width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-color"
    }
  }, [_vm._v("Height")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-border-radius"
    }
  }, [_vm._v("Max Width")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_w-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("width")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_h-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("height")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mxw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("max-width")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-32px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("max-width")]), _vm._v(" นั้น เราตัดสินใจที่จะใช้\n          "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mxw-*")]), _vm._v(" แทนที่จะเป็น "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mw-*")]), _vm._v("\n          นั่นก็เราต้องการจะมั่นใจว่าในกรณีที่เราเพิ่ม "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("min-width")]), _vm._v(" Class เข้ามาใน อนาคต\n          จะไม่มี Breaking Change ในส่วนนี้ 🙇\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_w-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_h-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mxw-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Percentage Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("10pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("20pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("30pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("40pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("50pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("60pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("70pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("80pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("90pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("100pct")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Box Size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Width -->\n<div class=\"_w-1px\"></div>\n<div class=\"_w-2px\"></div>\n<div class=\"_w-4px\"></div>\n<div class=\"_w-8px\"></div>\n<div class=\"_w-16px\"></div>\n<div class=\"_w-32px\"></div>\n<div class=\"_w-64px\"></div>\n<div class=\"_w-50pct\"></div>\n<div class=\"_w-100pct\"></div>\n\n<!-- Height -->\n<div class=\"_h-1px\"></div>\n<div class=\"_h-2px\"></div>\n<div class=\"_h-4px\"></div>\n<div class=\"_h-8px\"></div>\n<div class=\"_h-16px\"></div>\n<div class=\"_h-32px\"></div>\n<div class=\"_h-64px\"></div>\n<div class=\"_h-50pct\"></div>\n<div class=\"_h-100pct\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-1px"
  }, [_c('small', [_vm._v("._w-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-2px"
  }, [_c('small', [_vm._v("._w-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-4px"
  }, [_c('small', [_vm._v("._w-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-8px"
  }, [_c('small', [_vm._v("._w-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-16px"
  }, [_c('small', [_vm._v("._w-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-32px"
  }, [_c('small', [_vm._v("._w-32px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-64px"
  }, [_c('small', [_vm._v("._w-64px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-50pct"
  }, [_c('small', [_vm._v("._w-50pct")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _wsp-nw _w-100pct"
  }, [_c('small', [_vm._v("._w-100pct")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-1px"
  }, [_c('small', [_vm._v("._h-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-2px"
  }, [_c('small', [_vm._v("._h-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-4px"
  }, [_c('small', [_vm._v("._h-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-8px"
  }, [_c('small', [_vm._v("._h-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-16px"
  }, [_c('small', [_vm._v("._h-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-32px"
  }, [_c('small', [_vm._v("._h-32px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-64px"
  }, [_c('small', [_vm._v("._h-64px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300  _mgbt-4px _h-128px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-50pct"
  }, [_c('small', [_vm._v("._h-50pct")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _pst-rlt _h-100pct"
  }, [_c('small', [_vm._v("._h-100pct")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f799203","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicBoxSize.vue
// module id = 129
// module chunks = 0